import {Component, Injectable, OnInit, Pipe, PipeTransform} from '@angular/core';
import {ActivatedRoute} from '@angular/router';


@Injectable()
@Component({
  selector: 'app-settings-tab-group',
  templateUrl: './settings-tab-group.component.html',
  styleUrls: ['./settings-tab-group.component.scss']
})
export class SettingsTabGroupComponent implements OnInit, PipeTransform {
  selectedIndex: any;

  constructor(private _Activatedroute: ActivatedRoute) {
    _Activatedroute.queryParams.subscribe(params => {
      this.selectedIndex = params['selectedIndex'];
    });
  }

  ngOnInit() {
  }

  transform(items: any[], field: string, value: string): any[] {
    if (!items) {
      return [];
    }
    if (!field || !value) {
      return items;
    }

    return items.filter(singleItem =>
      singleItem[field].toLowerCase().includes(value.toLowerCase())
    );
  }

}


